export default "__VITE_ASSET__804bcae1__$_?component__"